import { createApp } from 'vue';
import App from './App.vue';
import router  from './router';
import './assets/admin.css'
// Se você decidir usar Pinia para o carrinho de compras no futuro,
// ele será importado e usado aqui também.

const app = createApp(App);

// Plugins
app.use(router);

// Montagem
app.mount('#app');
